export enum ModeKioskEnum {
  disabled = 0,
  enabledWithLogin = 1,
  enabledWithoutLogin = 2,
}
